export const SESSION_STORAGE = {
  'EMAIL_CODE': 'EMAIL_CODE'
}